import { CSSProperties } from "@remirror/theme";
import { Container } from "./styles";

interface propsInterface {
  margin?: number;
  gutter?: number;
  children: any;
  style?: CSSProperties;
  className?: string;
}

const Component = ({ children, margin, gutter, ...rest }: propsInterface) => {
  return (
    <Container margin={margin} gutter={gutter} {...rest}>
      {children}
    </Container>
  );
};

export default Component;
